<template>
    <div v-if="vehicle.aos_player" class="aos-gallery__container" :class="{ 'aos-gallery__container--reserved': isReserved }">
        <div v-show="currentlyVisible == 'gallery'" :id="galleryId"></div>
        <div v-show="currentlyVisible == 'spinner'" :id="spinnerId"></div>
        <div v-show="currentlyVisible == 'video'" :id="videoId"></div>
        <div v-show="currentlyVisible == 'internalPanorama'" ref="internalPanorama" style="width: 100%; height: 500px"></div>

        <div class="aos-gallery__buttons-container" :class="{'aos-gallery__buttons-container--1': numberOfButtons == 1, 'aos-gallery__buttons-container--2': numberOfButtons == 2, 'aos-gallery__buttons-container--3': numberOfButtons == 3, 'aos-gallery__buttons-container--4': numberOfButtons == 4}" v-if="numberOfButtons > 0">
            <button type="button" class="btn btn-gallery" v-if="numberOfImages > 0" @click="showGallery">
                Gallery ({{ numberOfImages }})
            </button>
            <button type="button" class="btn btn-gallery" v-if="hasVideo" @click="showVideo">
                Video
            </button>
            <button type="button" class="btn btn-gallery" v-if="hasPanorama" @click="showInternalPanorama">
                360&deg; Interior
            </button>
            <button type="button" class="btn btn-gallery" v-if="hasSpinner" @click="showSpinner">
                360&deg; Exterior
            </button>
        </div>
    </div>
</template>

<script>
import postscribe from 'postscribe';
import { Viewer } from '@photo-sphere-viewer/core';

export default {
    props: {
        vehicle: {
            required: true,
        },
        isReserved: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            readyForArtwork: false,
            aosVehiclePromise: null,
            aosVehicle: null,
            numberOfImages: null,
            hasPanorama: false,
            panoramaLoaded: false,
            hasSpinner: false,
            spinnerLoaded: false,
            hasVideo: false,
            videoLoaded: false,
            currentlyVisible: 'gallery',
            img: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkAQMAAABKLAcXAAAAA1BMVEX///+nxBvIAAAAAXRSTlMAQObYZgAAABRJREFUeNpjYBgFo2AUjIJRQE8AAAV4AAHYKaK4AAAAAElFTkSuQmCC',
        };
    },
    methods: {
        showSlide(slideToShow) {
            this.largeGallerySwiper.slideTo(slideToShow);
        },
        showGallery() {
            this.currentlyVisible = 'gallery';
        },
        showInternalPanorama() {
            if (!this.panoramaLoaded) {
                const test = new Viewer({
                    container: this.$refs["internalPanorama"],
                    panorama: this.aosVehicle.getInternalPanorama(),
                });
                // AosSDK.injectPanorama(this.internalPanoramaId, this.aosVehicle.getInternalPanorama(), this.aosVehicle.getPanoramaOptions());
                this.panoramaLoaded = true;
            }
            this.currentlyVisible = 'internalPanorama';
        },
        showSpinner() {
            if (!this.spinnerLoaded) {
                AosSDK.injectSpinner(this.spinnerId, this.aosVehicle.getAllThreeSixtyImages(), this.aosVehicle.getSpinnerOptions());
                this.spinnerLoaded = true;
            }
            this.currentlyVisible = 'spinner';
        },
        showVideo() {
            if (!this.videoLoaded) {
                AosSDK.injectVideo(this.videoId, this.aosVehicle.getVideoPlaylist(), this.aosVehicle.getPoster(), this.aosVehicle.getVideoOptions());
                this.videoLoaded = true;
            }
            this.currentlyVisible = 'video';
        },
        getAosToken() {
            return new Promise((resolve, reject) => {
                if (typeof this.vehicle.aos_token != 'undefined' && this.vehicle.aos_token) {
                    resolve(this.vehicle.aos_token);
                    return;
                }
                axios
                    .get('/api/used-vehicles/aos-token', {
                        headers: {
                            Accept: "application/json",
                        },
                    })
                    .then(response => {
                        resolve(response.data.token);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },
        setupGallery() {
            this.getAosToken().then(token => {
                const library = new AosSDK.Library(token);
                this.aosVehiclePromise = library.vehicle(this.vehicle.reg_no);
                this.aosVehiclePromise.then(aosVehicle => {
                    this.aosVehicle = aosVehicle;
                    // this.mediumImages = vehicle.getMediumImages();
                    // this.thumbnailImages = vehicle.getSmallImages();
                    // this.largeImages = vehicle.getLargeImages();
                    // this.videoURL = vehicle.getVideo();
                    // this.tags = vehicle.getTags();

                    this.$nextTick(function() {
                        const overview = aosVehicle.getOverview();
                        this.numberOfImages = overview.numberOfImages;
                        this.hasPanorama = overview.hasInternalPanorama;
                        this.hasSpinner = overview.hasExternalSpin;
                        this.hasVideo = overview.hasVideo;
                        AosSDK.injectGallerySet(this.galleryId, aosVehicle.getImageSet(), aosVehicle.getTagSet(), aosVehicle.getGalleryOptions(), 0, {"tag": {"damageIcon": "http://eu.cdn.autosonshow.tv/images/hazard.png", "featureColor": "#87ccd3"}});
                        // AosSDK.injectPanorama(this.internalPanoramaId, vehicle.getInternalPanorama(), vehicle.getPanoramaOptions());
                        // AosSDK.injectSpinner(this.spinnerId, vehicle.getAllThreeSixtyImages(), vehicle.getSpinnerOptions());
                        // AosSDK.injectVideo(this.videoId, vehicle.getVideoPlaylist(), vehicle.getPoster(), vehicle.getVideoOptions());
                        // this.largeGallerySwiper = new Swiper(this.$refs["largeImageGallery"], {
                        //     modules: [Navigation, Lazy],
                        //     grabCursor: true,
                        //     slidesPerView: 1,
                        //     spaceBetween: 10,
                        //     speed: 400,
                        //     direction: "horizontal",
                        //     lazy: true,
                        //     preloadImages: false,
                        // });

                        // this.thumbnailGallerySwiper = new Swiper(this.$refs["thumbnailGallery"], {
                        //     modules: [Navigation, Lazy],
                        //     grabCursor: true,
                        //     slidesPerView: "auto",
                        //     spaceBetween: 10,
                        //     speed: 400,
                        //     direction: "horizontal",
                        //     lazy: true,
                        //     preloadImages: false,
                        //     watchSlidesProgress: true,
                        // });
                    });
                }).catch(error => {
                    console.error('Error loading AOS SDK');
                    console.error(error);
                })
            })
        }
    },
    computed: {
        haveImages() {
            if (this.largeImages.length > 0) {
                return true;
            }
            return false;
        },
        galleryId() {
            return "gallery-" + this._uid;
        },
        internalPanoramaId() {
            return "internal-panorama-" + this._uid;
        },
        spinnerId() {
            return "spinner-" + this._uid;
        },
        videoId() {
            return "video-" + this._uid;
        },
        numberOfButtons() {
            let active = 0;
            if (this.numberOfImages > 0) {
                active++;
            }
            if (this.hasVideo) {
                active++;
            }
            if (this.hasPanorama) {
                active++;
            }
            if (this.hasSpinner) {
                active++;
            }
            return active;
        },
    },
    mounted() {
        if (!window.aosSDKLoaded) {
            postscribe(document.querySelector('head'), '<script src="https://media-player-sdk.aos.tv/latest/app-sdk.js"><\/script>', {
                afterAsync: () => {
                    window.aosSDKLoaded = true;
                    this.setupGallery();
                }
            });
        } else {
            this.setupGallery();
        }
    },
}
</script>

<style lang="scss">
    @import '../../../sass/used/utilities/details/_aos-gallery.scss';
</style>


// WEBPACK FOOTER //
// resources/assets/js/used-vue/components/AutosOnShowGallery.vue